var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { datadogLogs } from '@datadog/browser-logs';
import { UTMS } from '../../constants';
import { camelToSnake } from '../camel-to-snake';
import { removeDuplicate } from '../remove-duplicate';
import { snakeToCamel } from '../snake-to-camel';
var isValidUTMParam = function (paramKey) { return Boolean(paramKey.startsWith('utm') && UTMS.includes(paramKey)); };
export function formatUtm(queryParams) {
    var defaultUTMs = {
        utmSource: '',
        utmContent: '',
        utmMedium: '',
        utmCampaign: '',
        utmTerm: '',
    };
    try {
        var parsedUTMs = Object.keys(queryParams)
            .map(function (queryParamKey) { return snakeToCamel(queryParamKey); })
            .filter(function (queryParamKey) { return isValidUTMParam(queryParamKey); })
            .reduce(function (acc, utmParamKey) {
            var _a;
            var _b;
            return (__assign(__assign({}, acc), (_a = {}, _a[utmParamKey] = removeDuplicate((_b = queryParams[camelToSnake(utmParamKey)]) !== null && _b !== void 0 ? _b : queryParams[utmParamKey]), _a)));
        }, {});
        return parsedUTMs;
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred while attempting to retrieve UTM's from query data", {}, error);
        return defaultUTMs;
    }
}
//# sourceMappingURL=index.js.map